import { Link } from 'react-router-dom';
import type { SeccionConEnlace } from '../lib/diaADia';

/** Link chico, al lado del HelpTip del encabezado, a la sección del instructivo de esa pantalla. */
export function VerInstructivo({ seccion }: { seccion: SeccionConEnlace }) {
  return (
    <Link
      to={`/instructivos?seccion=${seccion}`}
      className="ml-1 align-middle text-sm font-medium text-brand-600 underline-offset-2 hover:text-brand-700 hover:underline focus-visible:underline focus-visible:outline-none"
    >
      Ver instructivo
    </Link>
  );
}
